import React, { useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Select from "react-select";
import { localApi } from "utils/imgApi";
import { useHistory } from "react-router-dom";
import Slide from "@material-ui/core/Slide";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Table from "components/Table/Tables.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import SweetAlert from "react-bootstrap-sweetalert";
import Tooltip from "@material-ui/core/Tooltip";
import Close from "@material-ui/icons/Close";

import styles from "assets/jss/material-dashboard-pro-react/views/viewCartStyle";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styleDailog from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(styDrop);
const useStyl = makeStyles(style);
const useStyleDailog = makeStyles(styleDailog);
// const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export default function OrderHistory() {
  const [addCart, setAddCart] = React.useState([]);
  const [client, setClient] = React.useState([]);
  const [clientId, setClientId] = React.useState("");
  const [clientid, setClientid] = React.useState("");
  const [Date, setDate] = React.useState("");
  const [arrSortList, setArrSortList] = React.useState("");

  const [expandedRows, setExpandedRows] = React.useState([]);
  const [expandState, setExpandState] = React.useState({});

  const [cartId, setCartId] = React.useState();
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();
  const classeAlert = useStyl();
  const classeDailog = useStyleDailog();
  const classTable = useStyles();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  function arrSorts(arr) {
    arr.sort((a, b) => a - b);
    arr.reverse();
    return arr;
  }

  function order(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  async function getClient() {
    const api =
      localApi + `/clientGroup/list/byAdminId/${userObj && userObj.id}`;
    const result = await fetch(api);
    const getResult = await result.json();
    setClient(getResult && getResult.filter((f) => f.type != "Crm"));
    // console.log(getResult.getResult);
  }

  useEffect(() => {
    getClient();
  }, []);

  const handleDatePicker = (Date) => {
    setDate(
      Date._d.getFullYear() +
        "-" +
        (Date._d.getMonth() + 1) +
        "-" +
        Date._d.getDate()
    );
  };

  function merge(...arrays) {
    let newArray = [];
    for (let i = 0; i < arrays.length; i++) {
      newArray.push(...arrays[i]);
    }
    return newArray;
  }

  const handleBoots = (bootselect) => {
    if (bootselect.value) {
      let newCut = bootselect.value.split("-");
      const ids = client.find((f) => f.mobile == newCut[1]);
      setClientid(ids && ids);
      // console.log(ids);
      axios
        .get(
          localApi +
            `/orders/list/byAdminAndClientIdwithzero/${userObj && userObj.id}/${
              ids.id
            }`
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data.length === 0) {
            setSubmitted(true);
            alertMsgOps("Data Not Found");
          } else {
            setAddCart(res && res.data);
            // console.log(res.data);
          }
        });
    }
    setClientId(bootselect);
  };

  const handleEpandRow = (event, userId) => {
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(userId);

    let obj = {};
    isRowExpanded ? (obj[userId] = false) : (obj[userId] = true);
    setExpandState(obj);
    // console.log(obj);

    // If the row is expanded, we are here to hide it. Hence remove
    // it from the state variable. Otherwise add to it.
    const newExpandedRows = isRowExpanded
      ? currentExpandedRows.filter((id) => id !== userId)
      : currentExpandedRows.concat(userId);
    setExpandedRows(newExpandedRows);

    const orId = addCart.find((f) => f.id === userId);
    // console.log(orId);
    // const oId = orId.payment.length - 1;
    const oId = orId.payment.map((p) => {
      return p.id;
    });
    // let l = oId.pop();
    // console.log(oId.sort((a,b) => b - a)[0]);
    setArrSortList(oId.sort((a, b) => b - a)[0]);
  };

  const handleRemove = (p) => {
    setSubmitteds(true);
    setCartId(p);
  };

  const handleConfirm = () => {
    // console.log("oooo", cartId);

    fetch(
      localApi + `/payment/delete/byAdminAndPaymentId/${userObj.id}/${cartId}`,
      {
        method: "DELETE",
      }
    )
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        if (res.message === "Deleted Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Deleted Succesfully !!!");
          setSubmittedConfirm(true);
        }
      });
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),
    menu: (state) => ({
      color: "#d81b60",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  const hideAlerts = () => {
    setSubmitteds(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  return (
    <div className={classes.productPage}>
      <GridContainer justify="center" alignItems="center">
        {/* <Card>
                    <CardBody> */}
        <GridContainer
          justify="center"
          alignItems="center"
          className={classes.selects}
        >
          <GridItem xs={12} sm={6} md={4} style={{ marginBottom: "3%" }}>
            <label>Select Company & Client Name</label>
            <Select
              styles={customStyles}
              className={classes.select}
              placeholder="Select Company & Client Name..."
              value={clientId}
              onChange={handleBoots}
              options={client.map((c) => {
                return {
                  label:
                    c && c.company
                      ? c.company + "-" + c.mobile
                      : c.firstname + " " + c.lastname + "-" + c.mobile,
                  value:
                    c && c.company
                      ? c.company + "-" + c.mobile
                      : c.firstname + " " + c.lastname + "-" + c.mobile,
                };
              })}
            />
          </GridItem>
        </GridContainer>

        {submitted ? (
          <SweetAlert
            type={alertType}
            style={{ display: "block", marginTop: "-100px" }}
            title={alertMsg}
            onConfirm={() => hideAlert()}
            confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
          />
        ) : null}
        {submitteds ? (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "100px" }}
            title="Are you sure?"
            onConfirm={handleConfirm}
            onCancel={() => hideAlerts()}
            confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
            cancelBtnCssClass={classeAlert.button + " " + classeAlert.danger}
            confirmBtnText="Yes, delete it!"
            cancelBtnText="Cancel"
            showCancel
          />
        ) : null}

        {submittedConfirm ? (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "100px" }}
            title="Deleted!"
            onConfirm={() => hideAlerts()}
            onCancel={() => hideAlerts()}
            confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
          >
            Your item has been deleted.
          </SweetAlert>
        ) : null}
      </GridContainer>

      <GridContainer>
        {clientId ? (
          <Card>
            <div className={classes.container}>
              <h3 className={classes.cardTitle}>Order History List</h3>
              <Table
                tableHead={[
                  <span className={classes.tableHead} key="sr">
                    Sr.No.
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="des"
                  >
                    Order Id
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="ctn"
                  >
                    Date
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="ctn"
                  >
                    Boxes/Dozan
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="qty"
                  >
                    Amount
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="qty"
                  >
                    More
                  </span>,
                ]}
                tableData={
                  addCart &&
                  addCart.map((c, index) => [
                    [
                      <span className={classes.OrderlistDescription}>
                        {index + 1}
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                      >
                        {c.id}
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                      >
                        {c.createDate.slice(0, -19)}
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                      >
                        {c.totalBox + " - " + "Units"}
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                      >
                        ₹ {Math.round(c.amount) + "/-"}
                      </span>,
                      <span>
                        <Button
                          link
                          className={
                            classes.headRight + " " + classes.actionButton
                          }
                          onClick={(event) => handleEpandRow(event, c.id)}
                        >
                          {expandState[c.id] ? (
                            <ArrowUpwardIcon style={{ color: "red" }} />
                          ) : (
                            <ArrowDownwardIcon style={{ color: "red" }} />
                          )}
                        </Button>
                      </span>,
                    ],
                    [
                      expandedRows.includes(c.id) ? (
                        <span>
                          {c.payment.map((p, index) => (
                            <span
                              style={{
                                marginTop: "20px",
                                marginBottom: "20px",
                              }}
                              key={p.id}
                            >
                              {index + 1}
                              <br />
                            </span>
                          ))}
                        </span>
                      ) : null,
                      expandedRows.includes(c.id) ? (
                        <span className={classes.headRight}>
                          {c.payment.map((p) => (
                            <span
                              style={{
                                marginTop: "20px",
                                marginBottom: "20px",
                              }}
                              key={p.id}
                            >
                              {p.id}
                              <br />
                            </span>
                          ))}
                        </span>
                      ) : null,
                      expandedRows.includes(c.id) ? (
                        <span className={classes.headRight}>
                          {c.payment.map((p) => (
                            <span
                              style={{
                                marginTop: "20px",
                                marginBottom: "20px",
                              }}
                              key={p.id}
                            >
                              {p.createDate.slice(0, -19)}
                              <br />
                            </span>
                          ))}
                        </span>
                      ) : null,
                      "",
                      expandedRows.includes(c.id) ? (
                        <span className={classes.headRight}>
                          {c.payment.map((p) => (
                            <span
                              style={{
                                marginTop: "20px",
                                marginBottom: "20px",
                              }}
                              key={p.id}
                            >
                              {p.received}
                              <br />
                            </span>
                          ))}
                        </span>
                      ) : null,
                      // "",
                      expandedRows.includes(c.id) ? (
                        <span>
                          {c.payment.map((p, index) => {
                            // const ap = index;
                            // console.log(ap);
                            // console.log(arrSortList);
                            return (
                              <span key={p.id}>
                                {p.id === arrSortList ? (
                                  <Tooltip
                                    id="close1"
                                    title="Payment Remove"
                                    placement="left"
                                    classes={{ tooltip: classes.tooltip }}
                                    key={c.id}
                                  >
                                    <Button
                                      link
                                      className={classes.actionButton}
                                      onClick={() => handleRemove(p.id)}
                                    >
                                      <Close style={{ color: "red" }} />
                                    </Button>
                                  </Tooltip>
                                ) : (
                                  ""
                                )}
                                <br />
                              </span>
                            );
                          })}
                        </span>
                      ) : null,
                      // "",
                    ],
                  ])
                }
              />
            </div>
          </Card>
        ) : (
          ""
        )}
      </GridContainer>
    </div>
  );
}
